import { useEffect } from 'react';

import { URL_PARAMS } from '@/enums';

export const useLogoutFromQueryParam = (logout: () => void, search: string) => {
  useEffect(() => {
    const logoutParam = new URLSearchParams(search).get(URL_PARAMS.LOGOUT);

    if (logoutParam) {
      logout();
    }
  }, [logout, search]);
};
